import React from "react";
import axios from 'axios';
import swal from "sweetalert";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import $ from "jquery";
import UserJpg from "../../../src/assests/images/user.jpg";
import './dashboardHeader.css';
import moment from "moment";
import { resetMiscData, setAgentInfo, setDeviceInfo, setMiscCallBackUrl, setToken } from './../../redux/misc-data/misc-data.action';
import FinxPayLogo from "../../assests/images/finxpay.png";
import FinxPayIcon from "../../assests/images/logo.png";
import authReducer from './../../redux/auth/auth.reducer';
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
import { resetRetailerKyc, setROId } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import { setCallBackUrl } from "../../redux/auth/auth.action";
const httpClient = axios.create();
class HeaderCommon extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            message: '',
            retailerBalanceVal: 0,
            currentLocation: { lat: 0, lng: 0 },
            markers: [],
            bounds: null
        }
    }
    ipDetectUrls = ['https://api.db-ip.com/v2/free/self/', 'https://api.ipify.org/?format=json', 'https://geolocation-db.com/json/']
    ips = [];
    map = '';
    markerArray = [];

    reLoadLocation(val, deviceInfo) {
        var reLoadLocationNeeded = false;
        var coorDinates = deviceInfo.location.coordinates;

        if (coorDinates == undefined || coorDinates == null) {
            reLoadLocationNeeded = true;
        } else {
            if (coorDinates.length > 0) {

                var value = coorDinates[0];
                if (value == 0.00 || value == '0.00') {
                    reLoadLocationNeeded = true;
                }
            }

        }


        if (val == true) {

            if (reLoadLocationNeeded == true) {
                if (navigator.geolocation) {

                    navigator.geolocation.getCurrentPosition(this.showPosition, this.posError);

                    // Passing in a success callback and an error callback fn}  // Alert is browser does not support geolocation
                } else {
                    swal({
                        title: "Geolocation is not supported by this browser.Try different browser!",
                        icon: "warning",
                        button: true,
                        dangerMode: false,
                    }).then(() => {

                    });
                    //alert("Geolocation is not supported by this browser.Try different browser.");
                    var deviceInfo1 = this.props.deviceInfo;

                    if (deviceInfo1.ip == undefined ||
                        deviceInfo1.ip == null || deviceInfo1.ip == '' ||
                        deviceInfo1.ip == '127.0.0.1') {
                        for (var i = 0; i < this.ipDetectUrls.length; i++) {
                            if (this.ips.length == 0) {
                                this.callIp(this.ipDetectUrls[i], deviceInfo1);
                            }
                        }
                    }
                }
            } else {
                console.log('already location captured');
                var deviceInfo1 = this.props.deviceInfo;

                if (deviceInfo1.ip == undefined ||
                    deviceInfo1.ip == null || deviceInfo1.ip == '' ||
                    deviceInfo1.ip == '127.0.0.1') {
                    for (var i = 0; i < this.ipDetectUrls.length; i++) {
                        if (this.ips.length == 0) {
                            this.callIp(this.ipDetectUrls[i], deviceInfo1);
                        }
                    }
                }
            }
        } else {
            navigator.geolocation.getCurrentPosition(this.showPosition, this.posError);
            var deviceInfo1 = this.props.deviceInfo;

            if (deviceInfo1.ip == undefined ||
                deviceInfo1.ip == null || deviceInfo1.ip == '' ||
                deviceInfo1.ip == '127.0.0.1') {
                for (var i = 0; i < this.ipDetectUrls.length; i++) {
                    if (this.ips.length == 0) {
                        this.callIp(this.ipDetectUrls[i], deviceInfo1);
                    }
                }
            }
        }
    }

    componentDidMount() {

        var deviceInfo = this.props.deviceInfo;
        this.reLoadLocation(true, deviceInfo);
        // var agentNull=false;
        // var tokenNull=false;
        // if (this.props.agentInfo == undefined || this.props.agentInfo == null ||
        //     this.props.agentInfo == '') {
        //         agentNull=true;

        // }else{
        //     if(this.props.agentInfo.id == undefined || this.props.agentInfo.id == null ||
        //         this.props.agentInfo.id == ''){
        //             agentNull=true;

        //         }
        // } 
        // if (this.props.token == undefined || this.props.token == null ||
        //     this.props.token == '') {
        //         tokenNull=true;

        // }


        // if (agentNull==true || tokenNull == true ||
        //     (agentNull==true && tokenNull == true )) {
        //     localStorage.setItem("token","empty");
        //     localStorage.setItem("agent","empty");
        //     this.reCalculateToken();
        // }else{
        //     localStorage.setItem("token",this.props.token);
        //     localStorage.setItem("agent",this.props.agentInfo.id);           
        // }

    }


    posError = () => {
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then(res => {
                //alert(res.state)
                if (res.state !== 'granted') {
                    swal({
                        title: "*Enable location permissions for this website in your browser settings and refresh the page.",
                        icon: "warning",
                        button: true,
                        dangerMode: false,
                    }).then(() => {

                    });
                    //alert('*Enable location permissions for this website in your browser settings and refresh the page.')
                }
            })
        }
        else {
            swal({
                title: "Unable to access your location.Try updated browser version",
                icon: "warning",
                button: true,
                dangerMode: false,
            }).then(() => {

            });
            //alert('Unable to access your location. You can continue by submitting location manually.')
            // Obtaining Lat/long from address necessary
        }

        var deviceInfo = this.props.deviceInfo;

        if (deviceInfo.ip == undefined ||
            deviceInfo.ip == null || deviceInfo.ip == '' ||
            deviceInfo.ip == '127.0.0.1') {
            for (var i = 0; i < this.ipDetectUrls.length; i++) {
                if (this.ips.length == 0) {
                    this.callIp(this.ipDetectUrls[i], deviceInfo);
                }
            }
        }

    }


    // Geolocation success callback fnconst 
    showPosition = (position) => {
        let lat = position.coords.latitude
        // You have obtained latitude coordinate!
        let long = position.coords.longitude

        var coordinates = [];
        coordinates.push(lat);
        coordinates.push(long);

        var geoLocation = {
            type: 'Point',
            coordinates: coordinates

        }

        var deviceInfo = this.props.deviceInfo;
        deviceInfo.location = geoLocation;

        if (deviceInfo.ip == undefined ||
            deviceInfo.ip == null || deviceInfo.ip == '' ||
            deviceInfo.ip == '127.0.0.1') {
            for (var i = 0; i < this.ipDetectUrls.length; i++) {
                if (this.ips.length == 0) {
                    this.callIp(this.ipDetectUrls[i], deviceInfo);
                }
            }

        } else {
            store.dispatch(setDeviceInfo(deviceInfo))
        }

        this.setState({
            locationLoading: 'completed'
        })

    }


    callIp = (url, deviceInfo) => {
        httpClient.get(url).then((ip) => {

            if (url == 'https://api.db-ip.com/v2/free/self/') {
                var ipVal = ip.data.ipAddress;
                if (ipVal.split('.').length == 4) {
                    if (!this.ips.includes(ipVal)) {
                        this.ips.push(ipVal)
                        deviceInfo.ip = ipVal;
                        store.dispatch(setDeviceInfo(deviceInfo))

                        //alert('ip address from https://api.db-ip.com/v2/free/self/....' + JSON.stringify(ip.data.ipAddress));
                    } else {
                        console.log('ip already added');

                    }
                }




            }
            if (url == 'https://api.ipify.org/?format=json') {
                var ipVal = ip.data.ip;
                if (ipVal.split('.').length == 4) {
                    if (!this.ips.includes(ipVal)) {
                        this.ips.push(ipVal)
                        deviceInfo.ip = ipVal;
                        store.dispatch(setDeviceInfo(deviceInfo))
                        //alert('ip address from https://api.ipify.org/?format=json....' + JSON.stringify(ip.data.ip));
                    } else {
                        console.log('ip already added');

                    }
                }

            }
            if (url == 'https://geolocation-db.com/json/') {
                var ipVal = ip.data.IPv4;
                if (ipVal.split('.').length == 4) {
                    if (!this.ips.includes(ipVal)) {
                        this.ips.push(ipVal)
                        deviceInfo.ip = ipVal;
                        store.dispatch(setDeviceInfo(deviceInfo))
                        //alert('ip address from https://geolocation-db.com/json/....' + JSON.stringify(ip.data.IPv4));
                    } else {
                        console.log('ip already added');

                    }
                }

            }

        }).catch(err => {
        })

    }

    // reCalculateToken = () => {
    //     var requesterId = process.env.REACT_APP_REQUESTERID;
    //     var url = '/api/v1/cms/user/auth';
    //     const requestHeader = {
    //         msgType: "AUTHORIZE_WHITELABEL_USER",
    //         service: 'CMS',
    //         src: "login",
    //         dst: "dashboard",
    //         channel: "WHITELABEL",
    //         requesterId: requesterId,
    //         requestId: uuidv4(),//filled by the 3rd party requester
    //         time: moment().utc(),
    //         traceId: uuidv4(),
    //     }


    //     var authorizeRequest = {
    //         header: requestHeader,
    //         device: this.props.deviceInfo,
    //         encData: this.props.encDataLoad

    //     }
    //     httpClient.post(url, authorizeRequest
    //     ).then((response) => {
    //         console.log('login response' + JSON.stringify(response.data));

    //         if (response.data.response.msg == 'SUCCESS') {

    //             console.log('login time:', moment().format("DD-MM-YYYY hh:mm:ss"));
    //             var token = response.data.token;
    //             store.dispatch(setToken(token))
    //             store.dispatch(setAgentInfo(response.data.agent))
    //             if (
    //                 response.data.agent.status != null &&
    //                 response.data.agent.status != undefined &&
    //                 response.data.agent.status != '') {
    //                 store.dispatch(setROId(response.data.agent.internalRoId));
    //             }
    //             store.dispatch(setCallBackUrl('/cms-login'));
    //             store.dispatch(setMiscCallBackUrl('/cms-login'));

    //             setTimeout(() => {
    //                 history.push(window.location.pathname.replace('/', ''));
    //                 history.go();
    //             }, 1000);
    //         }
    //     }).catch(error => {
    //         swal({
    //             title: "Sorry!",
    //             text: 'Authentication Error! Please Click to Re-login',
    //             icon: "error",
    //             button: true,
    //             dangerMode: true,
    //         }).then(() => {
    //             history.push('/cms-login');
    //             history.go();
    //         });

    //     });
    // }

    componentWillUnmount() {
    }




    goBackUrl = () => {
        window.location.href = this.props.callBackUrl;
    }


    render() {

        return (
            <div class="header">
                {/* {(this.props.agentInfo == '' || this.props.token == '' ||
                    this.props.agentInfo == '' && this.props.token == '') &&
                    <div class="loading">Loading&#8230;</div>
                } */}
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-2 col-md-5 col-lg-6 col-xl-5">
                            <div class="logo">
                                <Link to="/dmt">
                                    <img src={'/images/' + this.props.logoName} alt="FinXpay" class="d-none d-sm-block" />

                                </Link>
                                <h3>{(window.location.href.toString().includes('bill') ||
                                    window.location.href.toString().includes('help') ||
                                    window.location.href.toString().includes('complaint-status')) ?
                                    'Bill Payment Service' :
                                    window.location.href.toString().includes('recharge') ?
                                        'Recharge' :
                                        window.location.href.toString().includes('aeps') ?
                                            'AePS' :
                                            window.location.href.toString().includes('taload') ?
                                                'TA Load' :
                                                (this.props.claimLoadShow == 'yes' && window.location.href.toString().includes('claim')) ?
                                                    'Claim Upload' :
                                                    window.location.href.toString().includes('dmt') ?
                                                        'Domestic Money Transfer' :
                                                        window.location.href.toString().includes('merchant-onboard') ? 'KYC' :
                                                            window.location.href.toString().includes('merchant-payout') && 'Merchant Payout'}</h3>
                            </div>
                        </div>

                        <div class="col-10 col-md-7 col-lg-6 col-xl-7">
                            <div class="profile-box">

                                <button type="button" class="goback"
                                    onClick={this.goBackUrl}>Go back {this.props.partner}</button>

                                <div class="lstlog">Last Login: <span>{moment(this.props.agentInfo.lastLogin).format('DD-MM-YYYY hh:mm:ss')}</span></div>
                                <div class="usrnm">Hi, <span>{this.props.agentInfo.kioskName}</span> - <span>
                                    {this.props.agentInfo.id}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner, logoName, claimLoadShow, deviceInfo, encDataLoad }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner, logoName, claimLoadShow,
    deviceInfo, encDataLoad,
    callBackUrl
});




export default connect(mapStateToProps, null)(HeaderCommon);
